import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Link, FolderOpen, FileText, Sun, Moon, HelpCircle, Info, Shield, Settings, LogOut, Cloud } from 'lucide-react';
import { RefindIcon } from '../base';
import { useDrawerMenuItems } from '../../hooks/useDrawerMenuItems';
import { useAuth, useAppModals } from '../../hooks';
import styles from './Sidebar.module.css';

const ICON_MAP: Record<string, typeof Sun> = {
  sun: Sun,
  moon: Moon,
  'help-circle': HelpCircle,
  info: Info,
  shield: Shield,
  settings: Settings,
  'log-out': LogOut,
};

export const Sidebar = () => {
  const { t } = useTranslation();
  const { isAuthenticated, fullName, email, avatarUrl } = useAuth();
  const { openAuthPrompt } = useAppModals();
  const menuItems = useDrawerMenuItems({ onCloseDrawer: () => {} });

  const initial = (fullName || email)?.charAt(0).toUpperCase();

  return (
    <aside className={styles.sidebar}>
      <div className={styles.branding}>
        <RefindIcon size={28} style={{ color: 'var(--color-accent)' }} />
        <span className={styles.logoText}>Refind</span>
      </div>
      <nav className={styles.nav}>
        <NavLink
          to="/"
          end
          className={({ isActive }) => (isActive ? styles.active : styles.link)}
        >
          <Link size={20} />
          <span>{t('tabs.links', 'Links')}</span>
        </NavLink>
        <NavLink
          to="/groups"
          className={({ isActive }) => (isActive ? styles.active : styles.link)}
        >
          <FolderOpen size={20} />
          <span>{t('tabs.groups', 'Groups')}</span>
        </NavLink>
        <NavLink
          to="/files"
          className={({ isActive }) => (isActive ? styles.active : styles.link)}
        >
          <FileText size={20} />
          <span>{t('tabs.files', 'Files')}</span>
        </NavLink>
      </nav>
      <div className={styles.menuSection}>
        {menuItems.map((item) => {
          const Icon = ICON_MAP[item.icon] ?? Info;
          return (
            <button
              key={item.id}
              type="button"
              onClick={item.onPress}
              className={item.destructive ? styles.menuItemDestructive : styles.menuItem}
            >
              <Icon size={20} />
              <span>{item.label}</span>
            </button>
          );
        })}
      </div>
      <div className={styles.userSection}>
        {isAuthenticated ? (
          <div className={styles.userInfo}>
            {avatarUrl ? (
              <img src={avatarUrl} alt="" className={styles.userAvatar} />
            ) : (
              <span className={styles.userInitial}>{initial}</span>
            )}
            <span className={styles.userName}>{fullName || email || ''}</span>
          </div>
        ) : (
          <button
            type="button"
            onClick={openAuthPrompt}
            className={styles.entrarBtn}
            title={t('header.syncAcrossDevices')}
          >
            <Cloud size={20} />
            <span>{t('header.signIn', 'Sign in')}</span>
          </button>
        )}
      </div>
    </aside>
  );
};
